import { el } from 'redom';
import * as ReactDOM from 'react-dom';

import application from 'application';
import serverInterface from 'server-interface';

import internalEventCodes from 'event-system/codes/internal';

import { getPropertyValues } from 'utilities/collection';

import { render as contactsInputRenderer } from 'root/startup-view/customers/customer-message-editor/contacts-input';

import {
  getChangeStats
} from './utilities';

class ParticipantsInput {

  constructor(configuration) {

    this.placeholder = configuration.placeholder;
    this.participants = configuration.participants;
    this.readOnly = configuration.readOnly;
    this.contactRenderer = configuration.contactRenderer;
    this.onAdd = configuration.onAdd || function noop() {};
    this.onRemove = configuration.onRemove || function noop() {};
    this.previousParticipantIds = getPropertyValues(this.participants, '_id');
    this.participantIds = getPropertyValues(this.participants, '_id');
    this.onChange = configuration.onChange || function noop() {};

    this.el = this.renderInput();

  }

  renderInput() {

    const self = this;
    const mountPoint = el('.participants-input.hide-scrollbar');

    const component = contactsInputRenderer({
      contactRenderer: this.contactRenderer,
      disabled: this.readOnly === true,
      autoFocus: false,
      contacts: (this.participants),
      placeholder: this.placeholder,
      limit: 10,
      allowManualContact: false,
      onChange(contacts) {
        self.handleParticipantsChange(contacts);
      },
      addContact: this.tryCreateContact.bind(this),
      canRemove(contact) {
        return contact.startupUserId !== application.getUser()._id;
      }
    });

    ReactDOM.unmountComponentAtNode(mountPoint);
    ReactDOM.render(component, mountPoint);

    return mountPoint;

  }

  async tryCreateContact(emailAddress) {

    try {

      const startupUser = await serverInterface.startup.users.customers.createCustomerForEmailAddress({ emailAddress });

      const startupUserId = startupUser._id;

      const contact = {
        _id: startupUserId,
        name: startupUser.fullName || startupUser.email,
        value: startupUser.email,
        profilePicture: startupUser.profilePicture,
        startupUserId
      };

      return contact;

    } catch (exception) {

      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Please enter valid email address',
        seconds: 5,
        type: 'error'
      });

      return null;

    }

  }

  handleParticipantsChange(contacts) {

    const changeStats = getChangeStats(this.participantIds, contacts);

    if (changeStats.added === true) {
      this.onAdd(changeStats.contact);
    } else if (changeStats.removed === true) {
      this.onRemove(changeStats.contact);
    }

    const participantIds = getPropertyValues(contacts, 'startupUserId');

    this.participantIds = participantIds;

    const modified = JSON.stringify(this.participantIds) !== JSON.stringify(this.previousParticipantIds);

    this.onChange({ value: [...this.participantIds], modified, participants: contacts });

  }

  getValue() {

    return this.participantIds;

  }

  setErrors(errors) {}

  clearErrors() {}

}

export default ParticipantsInput;